import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const REDIRECTPAGE_LEGACY_FIELD_ORDER = [
  "redirect_to"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  redirectPageDescriptor: _generatedRedirectPageDescriptor,
  redirectPageBlocDefinition,
  redirectPageDashboardLayout,
  redirectPageConfig,
  redirectPageResolveConfig,
  redirectPageProperties,
} = doodBlockConfig(
  {
    name: "Redirect page",
    internal_name: "Redirect page",
    defaultParent: [/^Main Layout$/i],
    componentType: 'RedirectPageComponent',
    category: 'page',
    description: "Redirect page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
  },

  () => ({
    redirect_to: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.redirect-page.redirect-to.label",
        help: "pages.blocks.redirect-page.redirect-to.help",
        defaultMode: "page",
        modes: [
          "page",
          "modal",
          "mailto",
          "external",
          "navigationBack",
          "anchor",
        ],
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.redirect-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.redirect-page.fieldset.redirect.label",
            fields: ["redirect_to"],
          },
        ],
      },
    ],
  })
);

export function redirectPageDescriptor(): IBlockDescriptor;
export function redirectPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function redirectPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedRedirectPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedRedirectPageDescriptor, redirectPageProperties, fieldOrder);
}

export {
  redirectPageBlocDefinition,
  redirectPageDashboardLayout,
  redirectPageProperties,
  redirectPageConfig,
  redirectPageResolveConfig,
};

export type RedirectPageConfig = typeof redirectPageConfig;
